const getDetailData = ({ workLook }) => ({
  widgetModal: workLook.detailData.widgetModal.widgetModal,
  recordId: workLook.detailData.widgetModal.recordId,
});

export default getDetailData;
